"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateNewValue = calculateNewValue;
var _selectionRange = require("./selectionRange");
var _getValue2 = require("./getValue");
var _isValidDateValue = require("./isValidDateValue");
var _isValidInputTimeValue = require("./isValidInputTimeValue");
function calculateNewValue(newEntry, element) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    var _getValue;
    return (_getValue = (0, _getValue2.getValue)(element)) != null ? _getValue : /* istanbul ignore next */
    '';
  }();
  var selectionRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, _selectionRange.getSelectionRange)(element);
  var deleteContent = arguments.length > 4 ? arguments[4] : undefined;
  var selectionStart = selectionRange.selectionStart === null ? value.length : selectionRange.selectionStart;
  var selectionEnd = selectionRange.selectionEnd === null ? value.length : selectionRange.selectionEnd;
  var prologEnd = Math.max(0, selectionStart === selectionEnd && deleteContent === 'backward' ? selectionStart - 1 : selectionStart);
  var prolog = value.substring(0, prologEnd);
  var epilogStart = Math.min(value.length, selectionStart === selectionEnd && deleteContent === 'forward' ? selectionEnd + 1 : selectionEnd);
  var epilog = value.substring(epilogStart, value.length);
  var newValue = "".concat(prolog).concat(newEntry).concat(epilog);
  var newSelectionStart = prologEnd + newEntry.length;
  if (element.type === 'date' && !(0, _isValidDateValue.isValidDateValue)(element, newValue)) {
    newValue = value;
  }
  if (element.type === 'time' && !(0, _isValidInputTimeValue.isValidInputTimeValue)(element, newValue)) {
    if ((0, _isValidInputTimeValue.isValidInputTimeValue)(element, newEntry)) {
      newValue = newEntry;
    } else {
      newValue = value;
    }
  }
  return {
    newValue: newValue,
    newSelectionStart: newSelectionStart
  };
}